import { createContext, useContext, useEffect, useRef } from 'react';

export const CrmSidebarContext = createContext<((toggle: (() => void) | null) => void) | null>(null);

/** Shared shell geometry, independent of department navigation and identity. */
export const CrmShellPresentationContext = createContext<{
  pilot: boolean;
  homePath?: string;
  hasSidebar?: boolean;
  openHelp?: () => void;
  registerHelp?: (open: () => void) => () => void;
  scrollTarget: HTMLElement | null;
  registerScrollTarget: (node: HTMLElement | null) => void;
}>({ pilot: false, scrollTarget: null, registerScrollTarget: () => undefined });

export function useCrmShellPresentation() { return useContext(CrmShellPresentationContext); }

/** Register the existing layout's navigation controller with the shared header. */
export function useCrmSidebar(toggle: () => void) {
  const register = useContext(CrmSidebarContext);
  const latest = useRef(toggle);
  useEffect(() => { latest.current = toggle; });
  useEffect(() => {
    register?.(() => latest.current());
    return () => register?.(null);
  }, [register]);
}
